export const SOADocumentType = Object.freeze({
  Invoice: 0,
  DepositInvoice: 1,
  CreditNote: 2,
  DebitNote: 3,
  Receipt: 4
})

export const SOADocumentStatus = Object.freeze({
  Normal: 0,
  Void: 1
})

export const SOADocumentVATApplyType = Object.freeze({
  SameAsBranch: 0,
  Exempt: 1
})

export const SOADocumentDueDateType = Object.freeze({
  None: 0,
  Immediate: 1,
  NetDays: 2
})

export const ItemProductType = Object.freeze({
  FunNow: 0,
  Manager: 1,
  Eatigo: 2
})

export const ItemServiceType = Object.freeze({
  PlatformServiceFee: 0,
  ProcessingFee: 1,
  SubscriptionFee: 2,
  CoverFee: 3,
  SMSServiceFeeFree: 4,
  SMSServiceFee: 5,
  CollectionAdj: 6,
  ChargeAdj: 7,
  Total: 8,
  SMSTableapp: 9,
  SystemSetupFee: 10,
  PromoCode: 11,
  Deposit: 12,
  FreeCovers: 13,
  Other: 99
})

export const SOAInvoiceType = Object.freeze({
  General: 0,
  Custom: 1,
  Deposit: 2
})

export const SOANoteType = Object.freeze({
  Debit: 0,
  Credit: 1
})

export const SOANoteIsECV = Object.freeze({
  False: 0,
  True: 1
})
